
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/profile",
      function () {
        return require("private-next-pages/candidate/profile/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/profile"])
      });
    }
  